import { render, staticRenderFns } from "./advertList.vue?vue&type=template&id=ecf2ba6c&scoped=true"
import script from "./advertList.vue?vue&type=script&lang=js"
export * from "./advertList.vue?vue&type=script&lang=js"
import style0 from "./advertList.vue?vue&type=style&index=0&id=ecf2ba6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf2ba6c",
  null
  
)

export default component.exports